/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Credentials/view.blocks to change it.
import BackToSignInAction from './BackToSignInAction/index'
import Email from './Email/index'
import Password from './Password/index'
import PasswordRules from './PasswordRules/index'
import React from 'react'
import ResetAction from './ResetAction/index'



/** @type {import('Simple/types.js').View} */
export default function Credentials({
  children,
  viewPath = "/App/Auth/ResetPasswordConfirm/Credentials"
  
}) {
  return (<React.Fragment
>
<Email
  viewPath={`${viewPath}/Email`}
/>
<Password
  viewPath={`${viewPath}/Password`}
/>
<PasswordRules
  viewPath={`${viewPath}/PasswordRules`}
/>
<ResetAction
  viewPath={`${viewPath}/ResetAction`}
/>
<BackToSignInAction
  viewPath={`${viewPath}/BackToSignInAction`}
/>
{children}
</React.Fragment>)
}